// extracted by mini-css-extract-plugin
export default {"anonymousAvatar":"kUkn98","withBorder":"AiybVb","filter":"feHRWB"};